import React, { useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import { makeGetTask } from 'selectors/tasks';
import { makeGetMilestone } from 'selectors/milestones';

import { useCanUser } from 'shared-hooks/permission';
import { isTempId } from 'utils/helpers';

import TaskDueDatePicker from 'components/TaskDueDatePicker';
import DateTime from 'components/DateTime';
import Tooltip from 'components/tooltip';

import IconCalendarSimple from 'icons/icon-calendar-simple';

const TaskDueDate = ({ id, dueDate, completed, createdBy, withIcon, withFromNow, showQuickOptions = true, dateFormat = 'dateTimeShort', xAlign = 'right', defaultXPosition = 'left', tooltipPlacement, onChange, t }) => {
    const isTemp = isTempId(id);
    const dateCtrl = useRef(null);
    const canEdit = useCanUser('editTask', createdBy);

    const handleClick = useCallback(() => {
        if (!dateCtrl.current) {
            return;
        }

        dateCtrl.current.show();
    }, [dateCtrl]);

    return (
        <div className={'task-due-date meta-item with-tooltip task-action' + (canEdit ? ' can-edit' : '') + (moment().diff(dueDate) > 0 && !completed ? ' text-danger' : '')} onClick={handleClick}>
            {
                withIcon ? (
                    <span className="meta-icon">
                        <IconCalendarSimple />
                    </span>
                ) : null
            }

            {
                dueDate ? (
                    <React.Fragment>
                        <Tooltip showDelay={200} withTooltipHover={false} placement={tooltipPlacement} tooltip={<DateTime format="fullDateTime">{dueDate}</DateTime>} disabled={dateFormat === 'fullDateTime'}>
                            <div>
                                <DateTime format={dateFormat}>{dueDate}</DateTime>
                            </div>
                        </Tooltip>

                        {
                            withFromNow ? (
                                <small className="control-text-additional"><DateTime fromNow>{dueDate}</DateTime></small>
                            ) : null
                        }
                    </React.Fragment>
                ) : null
            }

            {
                canEdit && !isTemp ? (
                    <React.Fragment>
                        {
                            !dueDate ? (
                                <span className="placeholder action-text">
                                    { t('Add') }
                                </span>
                            ) : null
                        }

                        <TaskDueDatePicker
                            id={id}
                            xAlign={xAlign}
                            defaultXPosition={defaultXPosition}
                            showQuickOptions={showQuickOptions}
                            onChange={onChange}
                            provideController={dateCtrl}
                        />
                    </React.Fragment>
                ) : null
            }
        </div>
    );
};

const makeMapStateToProps = () => {
    const getTask = makeGetTask();
    const getMilestone = makeGetMilestone();

    return ({ tasks, milestones }, ownProps) => {
        const task = getTask(tasks.items, ownProps.id);

        return {
            completed: task?.completed,
            dueDate: task?.due_date,
            createdBy: task?.created_by
        }
    }
}

export default connect(makeMapStateToProps)(React.memo(withTranslation('common')(TaskDueDate)));
